/*
 ** 全局域名等变量维护 复用个人中心
 ** 127.0.0.1  127.0.0.1  proxy
 ** focus-dev  .focus-dev || .focustest
 ** focus-dev  .focus-dev || .focustest
 ** focus  .focus
 */

var byProxy = false;
var mainDomain, oldMainDomain, loginUrl, otherDomain,loginDomain;

/* 本地开发走proxy */
if (/\d+\.\d+\.\d+\.\d+/.test(location.host)) {
    byProxy = true;
    //loginUrl = "//login.focus-dev.cn/login";
}
/* 测试线上等环境 */
if (!byProxy) {
    var hostArr = location.hostname.split('.');

    // 旧项目测试环境 .focustest  新项目.focus-dev||.focus-test等
    mainDomain = "." + hostArr[hostArr.length - 2] + '.' + hostArr[hostArr.length - 1];
    otherDomain = mainDomain;

    if (/(focus-(.*))/.test(location.host)) {
        oldMainDomain = ".focustest.cn";
        //loginUrl = "//fe" + mainDomain + "/login";
        loginUrl = "//login" + mainDomain + "/login";

        var matched = /((focus-(test|dev))\d+\.cn)/.exec(
            location.host);
        if (matched && matched[0]) { //比如feature走fe
            otherDomain = '.' +  matched[2] + '.cn';
            loginUrl = "//fe" + mainDomain + "/login";
            loginDomain = "//fe" + mainDomain;
        }

    } else {
        oldMainDomain = ".focus.cn";
        loginUrl = "//login.focus.cn/login";

    }

}

module.exports = {
    mock: false,
    mainDomain: byProxy ? "127.0.0.1" : mainDomain,
    oldMainDomain: oldMainDomain,

    // 生态接口拼图规则
    PHOTO_DOMAIN: "https://t4-res.focus-img.cn",
    PHOTO_STYLE_L: "sh345x190sh",
    /* 直播 */
    PHOTO_STYLE_A: "sh210x150sh",
    /* 文章 */
    PHOTO_STYLE_H: "sh50x50sh",
    PHOTO_STYLE_LIVE: "sh373x373sh",

    /* 头像 */

    // 默认图
    "dftPhoto": "https://t-res.focus-img.cn/mp/rz/753815f7-8a82-4506-8905-f880c2931cef.png%26t%3D1490064374316",

    // 登录登出页规则
    "loginUrl": byProxy ? "/login" : loginUrl,
    "logoutUrl": byProxy ? "/login/logout" : loginUrl + "/logout",

    // 直播页访问规则
    "url_live": byProxy ? "https://zhibo.focus-dev.cn/page/live-share.html" : "https://zhibo" +
        mainDomain + "/page/live-share.html",

    "uDomain": byProxy ? "" : "//u" + mainDomain,
    "loginDomain": byProxy ? "" : "//login" + mainDomain,
    // 本地测试绑定qq/sina功能，请绑定后端host,并切换loginDomain
    //"loginDomain": byProxy ? "//login.focustest.cn" : "//login" + mainDomain,

    // h5主站
    "h5Domain": byProxy ? "http://m.focus-dev.cn" : "//m" + mainDomain,

    // 入驻 文章
    "mpsvDomain": byProxy ? "/mock" : "//mp-sv-extend" + otherDomain,
    // 入驻
    "mpDomain": byProxy ? "" : "//mp" + otherDomain,

    // 直播
    "liveDomain": byProxy ? "" : "//api-zhibo" + otherDomain,
    // 
    "accountInfo":byProxy?"":"//mp-fe-pc"+otherDomain,
    // bbs
    "bbsDomain": byProxy ? "http://bbs.focus-dev.cn" : "//bbs" + otherDomain
}



// WEBPACK FOOTER //
// ./src/config.js